<template>
  <v-sheet>
    <div>
      <v-row justify="center">
        <v-avatar size="150">
          <img src="@/assets/olho.jpg" />
        </v-avatar>
      </v-row>
      <v-row justify="center">
        <div class="text-h4">
          <strong>{{ user.name }}</strong>
        </div>
      </v-row>
    </div>
    <div class="text-h6 text-center">Salvos:</div>
    <v-container style="max-width: 100%">
      <div max-width="100%">
        <v-container>
          <div class="mx-auto mt-n4" max-width="100%">
            <v-container fluid>
              <v-row dense v-if="saved.length > 0">
                <v-col
                  v-for="saved_product in saved"
                  :key="saved_product._id"
                  @click="openProduct(saved_product.url_product)"
                >
                  <!-- :cols="value.flex" :md="value.md" -->
                  <v-card>
                    <v-img
                      @click="
                        loadProduct(
                          saved_product.url_shop,
                          saved_product.url_product
                        )
                      "
                      :src="saved_product.imagem"
                      class="d-flex flex-column justify-space-between"
                      width="100%"
                      height="250px"
                    />
                    <v-card-title class="ma-0 pa-0 pl-2">{{
                      saved_product.product
                    }}</v-card-title>
                    <v-card-actions class="ma-0 pa-0">
                      <v-card-title class="text-button ma-1 pa-0"
                        >R$ {{ saved_product.value }}
                      </v-card-title>
                      <v-spacer />
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
              <p v-else style="text-align: center">Nenhum produto salvo!</p>
            </v-container>
          </div>
        </v-container>
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  name: "Profile",
  data: () => ({
    user: [],
    saved: [],
    products: [],
  }),
  methods: {
    loadProduct(shop, url_product) {
      this.$axios.get("/product/" + url_product);
      this.$router.replace({
        path: "/negocio/" + shop + "/" + url_product,
      });
    },
  },
  mounted() {
    this.$axios
      .get("/user_email/" + this.$route.params.user)
      .then((response) => {
        this.user = response.data;
        if (this.user.length == 0) {
          this.$router.replace({
            name: "error404",
          });
        }
        document.title = `Olhadela - ` + this.user.name;
      });
    this.$axios.get("/saved").then((response) => {
      this.saved = response.data;
    });
  },
};
</script>
